import { GaImageResponsive } from '@ga/ui-components/image-responsive'

// @vue/component
export default {
  name: 'ga-product-card-media-item',

  components: {
    GaImageResponsive,
    // GaVideoResponsive,
  },

  props: {
    productId: {
      type: String,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
    isHovered: {
      type: Boolean,
      default: false,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
}
